/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldPlacement } from './FieldPlacement';
import {
    FieldPlacementFromJSON,
    FieldPlacementFromJSONTyped,
    FieldPlacementToJSON,
    FieldPlacementToJSONTyped,
} from './FieldPlacement';

/**
 * 
 * @export
 * @interface GetFieldPlacementsResponse
 */
export interface GetFieldPlacementsResponse {
    /**
     * Field placement configuration for the template
     * @type {Array<FieldPlacement>}
     * @memberof GetFieldPlacementsResponse
     */
    fieldPlacements: Array<FieldPlacement>;
}

/**
 * Check if a given object implements the GetFieldPlacementsResponse interface.
 */
export function instanceOfGetFieldPlacementsResponse(value: object): value is GetFieldPlacementsResponse {
    if (!('fieldPlacements' in value) || value['fieldPlacements'] === undefined) return false;
    return true;
}

export function GetFieldPlacementsResponseFromJSON(json: any): GetFieldPlacementsResponse {
    return GetFieldPlacementsResponseFromJSONTyped(json, false);
}

export function GetFieldPlacementsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFieldPlacementsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldPlacements': ((json['fieldPlacements'] as Array<any>).map(FieldPlacementFromJSON)),
    };
}

export function GetFieldPlacementsResponseToJSON(json: any): GetFieldPlacementsResponse {
    return GetFieldPlacementsResponseToJSONTyped(json, false);
}

export function GetFieldPlacementsResponseToJSONTyped(value?: GetFieldPlacementsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fieldPlacements': ((value['fieldPlacements'] as Array<any>).map(FieldPlacementToJSON)),
    };
}

